// extracted by mini-css-extract-plugin
export var labelWrapper = "_fy-0";